import { useEffect, useRef } from "react";

export default function AboutMe() {
  const detailsRef = useRef(null);

  useEffect(() => {
    const mobileQuery = window.matchMedia("(max-width: 600px)");
    const syncDetails = () => {
      detailsRef.current.open = !mobileQuery.matches;
    };

    syncDetails();
    mobileQuery.addEventListener("change", syncDetails);

    return () => mobileQuery.removeEventListener("change", syncDetails);
  }, []);

  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/Download.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <details ref={detailsRef} className="about--details">
          <summary className="about--summary">
            <h1 className="skills-section--heading">Über mich</h1>
          </summary>
          <div className="about--details--content">
            <p className="hero--section-description">
              Ich bin ein leidenschaftlicher Softwareentwickler mit einem Abschluss in <strong>Computer Engineering</strong> mit Schwerpunkt <strong>Software  Engineering</strong> von der <strong>Universität Duisburg-Essen</strong>. Meine Fachgebiete umfassen Webentwicklung, GUI-Design und die Programmierung robotischer Systeme mit ROS.
            </p>
            <p className="hero--section-description">
              Ich lege großen Wert auf sauberen Code, Nutzerzentrierung und kontinuierliches Lernen. Mein technisches Know-how wird ergänzt durch Erfahrungen im agilen Arbeiten (Scrum), Usability-Tests und Cloud-Zertifizierungen.
            </p>
          </div>
        </details>
      </div>
    </section>
  );
}
